import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';
export default function Screen5V2() {
    const { t } = useLang('theProductV2.Screen5V2');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen3-V2');

    return (
        <section
            className={`${css.comp}  GtmModuleData-section`}
            id="rapid-mag-Screen3-V2"
            data-section-id={'rapid-mag-Screen3-V2'}
            data-section-title={t('title')}
        > 
            <div className="title-box-pc">
                <EcoSectionCommon label={t('label')} title={t('title')} desc={t('desc')} />
            </div>
            <div className="title-box-h5">
                <EcoSectionCommon label={t('label_h5')} title={t('title')} desc={t('desc_h5')} />
            </div>

            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762138687849/screen3.png',
                        'https://websiteoss.ecoflow.com/upload/image/1762138410652/screen3.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1764926408262/screen5V2_h5.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1764926403438/screen5V2_h5.webp',
                    )}
                />
            </div>
        </section>
    );
}
